export const STACKING_URL = 'https://app.stacks.co/dashboard/my-dual-stacking';
